/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioMicAOffIcon16Light } from './MediaAudioMicAOffIcon16Light';
import { MediaAudioMicAOffIcon16Regular } from './MediaAudioMicAOffIcon16Regular';
import { MediaAudioMicAOffIcon16Solid } from './MediaAudioMicAOffIcon16Solid';
import { MediaAudioMicAOffIcon20Light } from './MediaAudioMicAOffIcon20Light';
import { MediaAudioMicAOffIcon20Regular } from './MediaAudioMicAOffIcon20Regular';
import { MediaAudioMicAOffIcon20Solid } from './MediaAudioMicAOffIcon20Solid';
import { MediaAudioMicAOffIcon24Regular } from './MediaAudioMicAOffIcon24Regular';
import { MediaAudioMicAOffIcon24Solid } from './MediaAudioMicAOffIcon24Solid';
import { MediaAudioMicAOffIcon32Regular } from './MediaAudioMicAOffIcon32Regular';
import { MediaAudioMicAOffIcon64Regular } from './MediaAudioMicAOffIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioMicAOffIcon16Light,
        regular: MediaAudioMicAOffIcon16Regular,
        solid: MediaAudioMicAOffIcon16Solid,
    },
    20: {
        light: MediaAudioMicAOffIcon20Light,
        regular: MediaAudioMicAOffIcon20Regular,
        solid: MediaAudioMicAOffIcon20Solid,
    },
    24: {
        regular: MediaAudioMicAOffIcon24Regular,
        solid: MediaAudioMicAOffIcon24Solid,
    },
    32: {
        regular: MediaAudioMicAOffIcon32Regular,
    },
    64: {
        regular: MediaAudioMicAOffIcon64Regular,
    },
};
export var MediaAudioMicAOffIcon = forwardRef('MediaAudioMicAOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
